export default __webpack_public_path__ + "static/media/4.3b409c1b.png";